import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
    NotificationSwitchComponent
} from "../notification-switch/notification-switch.component";
import {SubtitlesService} from "../../../core";
import {NgClass} from "@angular/common";

@Component({
  selector: 'notification-info',
  standalone: true,
    imports: [NotificationSwitchComponent, NgClass],
  templateUrl: './notification-info.component.html',
  styleUrl: './notification-info.component.scss'
})
export class NotificationInfoComponent {
    @Input({ required: true }) timeText!: string;
    @Input({ required: true }) isActive!: boolean;
    @Output() toggleSwitch = new EventEmitter();

    constructor(
        private subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    toggleSwitchEvent(): void {
        this.toggleSwitch.emit();
    }
}
